import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { currentUserInfo } from 'atoms';
import Header from 'components/Common/Header';
import { modifyMyPassword } from 'fetchers';
import { useNavigate } from 'react-router-dom';

const NewPassword = () => {
  // const {
  //   user: { no },
  // } = useRecoilValue(currentUserInfo);
  const [password, setPassword] = useState();
  const [passwordConfirm, setPasswordConfirm] = useState();
  const navigation = useNavigate();

  const handleChange = (e, target) => {
    if (target === 'password') {
      setPassword(e.target.value);
    } else {
      setPasswordConfirm(e.target.value);
    }
  };

  const handleConfirm = async () => {
    if (password === passwordConfirm) {
      // const passwordChangeResponse = await modifyMyPassword(password, no);
      // if (passwordChangeResponse.status === 200) {
      //   alert(passwordChangeResponse.message);
      //   navigation(-2);
      // } else {
      //   alert(passwordChangeResponse.data.error.message);
      // }
    } else {
      alert('비밀번호가 일치하지 않습니다.');
    }
  };

  return (
    <Container>
      <NewPasswordContainer className='d-flex flex-column'>
        <Header title='비밀번호 재설정' />
        <NewPasswordInputWrapper className='container-fluid pt-4'>
          <NewPasswordInput
            className='form-control pl-2'
            type={'password'}
            placeholder='새 비밀번호 영문 대소,숫자,특수기호 조합 8자리 이상'
            onBlur={(e) => handleChange(e, 'password')}
          />
        </NewPasswordInputWrapper>
        <NewPasswordInputWrapper className='container-fluid pt-3'>
          <NewPasswordInput
            className='form-control pl-2'
            type={'password'}
            placeholder='새 비밀번호를 재입력해주세요'
            onBlur={(e) => handleChange(e, 'confirm')}
          />
        </NewPasswordInputWrapper>

        <NewPasswordConfirmButton
          className='btn btn-primary text-white'
          onClick={handleConfirm}
        >
          변경
        </NewPasswordConfirmButton>
      </NewPasswordContainer>
    </Container>
  );
};

const Container = styled.div``;
const NewPasswordContainer = styled.section``;
const NewPasswordInputWrapper = styled.article``;
const NewPasswordInput = styled.input``;
const NewPasswordConfirmButton = styled.button`
  width: 100%;
  height: 64.85px;
  position: absolute;
  left: 0;
  bottom: 0;
  border: 0;
`;

export default NewPassword;
